import http from '@/utils/http.js'

/*
 * @DESC:api接口
 */
const   GET_PAY_RECORD_LIST = "/api/getPayRecordList",//获取支付记录
		GET_CASHIER_ORDER_INFO = "/api/getCashierOrderInfo",//收银台订单详情
		SYT_REFUNDS = "/api/sytRefunds";//申请退款
//	GET_CASHIER_STASTICS_LIST = "/api/getShopByCashierRecord",//获取收银台门店统计列表
	
//	GET_CASHIER_ORDER_INFO = "/api/getCashierOrderInfo",//收银台订单详情
//	EXPORT_CASHIER_LIST = "/api/exportCashierList",//导出门店收银台订单数据excel
//	GET_CASHIER_ORDER_COUNT = "/api/getCashierOrderCount",//获取门店收银台订单总页数
//	GET_CASHIER_REPORT = "/api/getCashierReport",//获取门店交易报表数据
//	GET_REPORT_COUNT = "/api/getReportCount",//获取财务报表总页数
//	EXPORT_FINANCE_LIST = "/api/exportFinanceList";//导出财务报表数据

export default {
	getPayRecordList: async({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		try{
			const data = await http.get(GET_PAY_RECORD_LIST, params)
			commit('GET_PAY_RECORD_LIST',data)
		}catch(e){
			throw e
		}
	},
	getCashierOrderInfo: async({
		commit
	}, params={}) => {
		
		try{
			const data = await http.get(GET_CASHIER_ORDER_INFO, params)
			commit('GET_CASHIER_ORDER_INFO', data);
		}catch(e){
			throw e
		}
	},
	sytRefunds: ({
		commit
	}, params={}) => {
		return http.post(SYT_REFUNDS, params)
	},
//	getCashierStastic: ({
//		commit
//	}, params={}) => {
//		return new Promise((resolve, reject) => {
//			http.get(GET_CASHIER_STASTICS_INFO, params)
//				.then((res = null) => {
//					//commit('GET_CASHIER_STASTICS_INFO', res);
//					resolve(res);
//				},(err)=>{
//					reject(err.message)
//				})
//		})
//	},
	

//	
//	getShopByCashierRecord: ({
//		commit
//	}, params={}) => {
//		return new Promise((resolve, reject) => {
//			http.get(GET_CASHIER_STASTICS_LIST, params)
//				.then((res = null) => {
//					commit('GET_CASHIER_STASTICS_LIST', res);
//					resolve(res);
//				},(err)=>{
//					reject(err.message)
//				})
//		})
//	},

//	
//	exportCashierList: ({
//		commit
//	}, params={}) => {
//		return new Promise((resolve, reject) => {
//			http.get(EXPORT_CASHIER_LIST, params)
//				.then((res = null) => {
//					//commit('GET_PAY_RECORD',res) // 后台获得全部数据
//					resolve(res);
//				},(err)=>{
//					reject(err.message)
//				})
//		})
//	},
//	
//	getCashierOrderCount: ({
//		commit
//	}, params={}) => {
//		return new Promise((resolve, reject) => {
//			http.get(GET_CASHIER_ORDER_COUNT, params)
//				.then((res = null) => {
//					resolve(res);
//				},(err)=>{
//					reject(err.message)
//				})
//		})
//	},
//	
//	getCashierReport: ({
//		commit
//	}, params={}) => {
//		return new Promise((resolve, reject) => {
//			http.get(GET_CASHIER_REPORT, params)
//				.then((res = null) => {
//					commit('GET_CASHIER_REPORT',res) // 后台获得全部数据
//					resolve(res);
//				},(err)=>{
//					reject(err.message)
//				})
//		})
//	},
//	
//	getReportCount: ({
//		commit
//	}, params={}) => {
//		return new Promise((resolve, reject) => {
//			http.get(GET_REPORT_COUNT, params)
//				.then((res = null) => {
//					resolve(res);
//				},(err)=>{
//					reject(err.message)
//				})
//		})
//	},
//	
//	exportFinanceList: ({
//		commit
//	}, params={}) => {
//		return new Promise((resolve, reject) => {
//			http.get(EXPORT_FINANCE_LIST, params)
//				.then((res = null) => {
//					resolve(res);
//				},(err)=>{
//					reject(err.message)
//				})
//		})
//	},
}


// WEBPACK FOOTER //
// ./src/store/mp/pay_manage/pay_record/actions.js